import React from 'react';
import { RetryErrorComponent } from '@/components/RetryErrorComponent';
import {
  useTranslation,
  usePersistedSessionState,
} from '@edreamsodigeo/frontend-core';
import { backToSearch } from '../utils/backToSearchNavigation';

export function RunTimeModalError({ isOpen, close = () => {} }) {
  const { t } = useTranslation();
  const [searchParameters] = usePersistedSessionState('searchParameters', {});

  const onReview = function () {
    window.location.assign('/');
  };

  const onRetry = function () {
    window.location.assign(backToSearch(searchParameters));
  };

  return (
    <RetryErrorComponent
      open={isOpen}
      title={t('pricefreeze.error.search.header')}
      text={t('pricefreeze.error.search.body')}
      retryText={t('pricefreeze.error.search.buttonReTry')}
      reviewText={t('pricefreeze.error.search.buttonReview')}
      onClose={close}
      onRetry={onRetry}
      onReview={onReview}
    />
  );
}
